import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/image';
import { Device, from, until } from '@helpers/media';
import { h4 } from '@helpers/typography';
import SimpleImage from '@stories/Components/SimpleImage/SimpleImage';
import { m } from 'framer-motion';
import styled from 'styled-components';
import { LayoutBreakpoint } from '../MarketSectorsSection.styles';
const Container = styled(m.div) `
  @media ${until(LayoutBreakpoint)} {
    border-bottom: 1px solid ${brand.grey.otherGrey};
  }
`;
const Header = styled.button `
  @media ${until(LayoutBreakpoint)} {
    display: flex;
    align-items: center;
    background: none;
    border: 0;
    color: currentColor;
    margin: 0;
    padding: 10px 0 0;
    width: 100%;
  }

  @media ${from(LayoutBreakpoint)} {
    position: relative;
    display: flex;
    align-items: flex-start;
    background: none;
    border: 0;
    color: currentColor;
    flex-direction: column;
    margin: 0;
    padding: 16px 24px 12px;
    width: 100%;
  }

  @media ${from(Device.Desktop)} {
    padding: 32px 80px 24px;
  }
`;
const Title = styled.div `
  ${h4}
  margin: 0;
`;
const Icon = styled(SimpleImage) `
  @media ${until(LayoutBreakpoint)} {
    display: none;
  }

  @media ${from(LayoutBreakpoint)} {
    display: block;
    height: 96px;
    margin-bottom: ${fluid(16, 30)};
    object-fit: contain;
    object-position: center;
    user-select: none;
    width: 96px;
  }

  @media ${from(Device.Desktop)} {
    height: 154px;
    width: 154px;
  }
`;
const Progress = styled.span `
  position: relative;
  bottom: -12px;
  display: block;
  border-top: 1px solid ${brand.grey.otherGrey};
  width: 100%;

  @media ${from(Device.Desktop)} {
    bottom: -24px;
  }

  @media ${until(LayoutBreakpoint)} {
    display: none !important;
  }
`;
const ProgressInner = styled(m.span) `
  display: block;
  background: var(--accentColor, ${brand.blue.base});
  height: 2px;
  transform: scaleX(0);
  transform-origin: left center;
  width: 100%;
`;
const ArrowWrapper = styled(m.span) `
  display: block;
  color: ${brand.grey.otherGrey};
  margin-left: auto;

  @media ${from(LayoutBreakpoint)} {
    display: none;
  }
`;
const Body = styled(m.div) `
  @media ${until(LayoutBreakpoint)} {
    overflow: hidden;
  }

  @media ${from(LayoutBreakpoint)} {
    display: none !important;
    height: 0 !important;
  }
`;
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(338, 151)}
  margin-top: 8px;
  margin-bottom: 16px;
`;
const Image = styled(SimpleImage) `
  ${imageCoverContainer()}
`;
const Content = styled.div `
  color: currentColor;
  ${fonts.helvetica.regular};
  margin: 0 0 0.5em;
  font-size: 16px;
  line-height: 26px;
  letter-spacing: -0.01em;
  margin-bottom: 16px;
`;
const CtaWrapper = styled.div `
  margin-bottom: 24px;
`;
const SectionItemStyles = {
    ArrowWrapper,
    Body,
    Container,
    Content,
    CtaWrapper,
    Header,
    Icon,
    Image,
    ImageWrapper,
    Progress,
    ProgressInner,
    Title,
};
export default SectionItemStyles;
